import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStore } from 'vuex'
import {
    Component,
    computed,
    defineAsyncComponent,
    onUpdated,
    shallowRef,
    watch,
} from 'vue'
import { componentsMappingByAppModule } from '@/features/general/LocationsViewHOC/config/componentsMappingByAppModule'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationsViewHOC',
  setup(__props) {

const store = useStore()

const chosenAppModule = computed(() => store.state.chosenAppModule)
const stepActiveId = computed(() => store.state.view.stepActiveId)

const defaultComponentImportFn =
    componentsMappingByAppModule[stepActiveId.value].default

const LocationViewComponentRef = shallowRef(
    componentsMappingByAppModule[stepActiveId.value]?.[
        chosenAppModule.value.id
    ] || defaultComponentImportFn
)
const LocationViewComponent = computed(() =>
    defineAsyncComponent(LocationViewComponentRef.value)
)

const setLocationViewComponent = (newStepActiveId, newChosenAppModuleId) => {
    const activeStepComponentMap = componentsMappingByAppModule[newStepActiveId]
    if (!activeStepComponentMap) return

    const componentImportFn =
        activeStepComponentMap[newChosenAppModuleId] || defaultComponentImportFn

    LocationViewComponentRef.value = componentImportFn
}

watch(
    [stepActiveId, () => chosenAppModule.value.id],
    ([newStepActiveId, newChosenAppModuleId]) => {
        setLocationViewComponent(newStepActiveId, newChosenAppModuleId)
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(LocationViewComponent.value)))
}
}

})